var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useRef } from 'react';
import { Colors } from '../ThemeProvider/type';
import { useSnippet } from './useSnippet';
/**
 * # Snippet
 *
 * 코드를 쉽게 공유할 때 사용하는 스니펫입니다.
 *
 * @param {SnippetProps} {@link SnippetProps}
 *
 * @example ```tsx
 * <Snippet text='npm init next-app' width='300px' type='success' fill />
 * ```
 */
export var Snippet = function (props) {
    var _a = useSnippet(props), _b = _a.width, width = _b === void 0 ? '300px' : _b, text = _a.text, handleCopy = _a.handleCopy, fill = _a.fill, otherProps = __rest(_a, ["width", "text", "handleCopy", "fill"]);
    var ref = useRef(null);
    return (<Container width={width} fill={String(fill)} {...otherProps} ref={ref}>
      {text.map(function (it, idx) { return (<Row key={"".concat(it, "-").concat(idx)} {...otherProps}>
          {it}
        </Row>); })}
      <CopyButton onClick={function () { var _a, _b; return handleCopy((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.innerText) !== null && _b !== void 0 ? _b : ''); }}>
        <svg viewBox='0 0 24 24' width='24' height='24' color='currentcolor' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' fill='none' shapeRendering='geometricPrecision'>
          <path d='M8 17.929H6c-1.105 0-2-.912-2-2.036V5.036C4 3.91 4.895 3 6 3h8c1.105 0 2 .911 2 2.036v1.866m-6 .17h8c1.105 0 2 .91 2 2.035v10.857C20 21.09 19.105 22 18 22h-8c-1.105 0-2-.911-2-2.036V9.107c0-1.124.895-2.036 2-2.036z'/>
        </svg>
      </CopyButton>
    </Container>);
};
var SnippetTypeMapper = function (_a) {
    var fill = _a.fill;
    return ({
        primary: {
            background: Colors.PRIMARY.BACKGROUND,
            border: Colors.PRIMARY.ACCENT_2,
            color: Colors.PRIMARY.FOREGROUND
        },
        secondary: {
            background: fill ? Colors.PRIMARY.ACCENT_5 : Colors.PRIMARY.BACKGROUND,
            border: Colors.PRIMARY.ACCENT_5,
            color: fill ? Colors.PRIMARY.BACKGROUND : Colors.PRIMARY.ACCENT_5
        },
        success: {
            background: fill ? Colors.SUCCESS.DEFAULT : Colors.PRIMARY.BACKGROUND,
            border: Colors.SUCCESS.DEFAULT,
            color: fill ? Colors.PRIMARY.BACKGROUND : Colors.SUCCESS.DEFAULT
        },
        error: {
            background: fill ? Colors.ERROR.DEFAULT : Colors.PRIMARY.BACKGROUND,
            border: Colors.ERROR.DEFAULT,
            color: fill ? Colors.PRIMARY.BACKGROUND : Colors.ERROR.DEFAULT
        },
        warning: {
            background: fill ? Colors.WARNING.DEFAULT : Colors.PRIMARY.BACKGROUND,
            border: Colors.WARNING.DEFAULT,
            color: fill ? Colors.PRIMARY.BACKGROUND : Colors.WARNING.DEFAULT
        },
        lite: {
            background: Colors.PRIMARY.ACCENT_1,
            border: Colors.PRIMARY.ACCENT_2,
            color: Colors.PRIMARY.FOREGROUND
        }
    });
};
var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, width = _a.width, type = _a.type, dark = _a.dark, fill = _a.fill;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    width: ", ";\n    max-width: 100%;\n    padding: 9px 42px 9px 12px;\n    box-sizing: border-box;\n    border-radius: 5px;\n    background: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n\n    ", "\n  "], ["\n    position: relative;\n    width: ", ";\n    max-width: 100%;\n    padding: 9px 42px 9px 12px;\n    box-sizing: border-box;\n    border-radius: 5px;\n    background: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n\n    ", "\n  "])), width, SnippetTypeMapper({ fill: fill === 'true' })[type]['background'], SnippetTypeMapper({ fill: fill === 'true' })[type]['border'], SnippetTypeMapper({ fill: fill === 'true' })[type]['color'], dark && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n    "], ["\n      background: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n    "])), theme.colors.PRIMARY.FOREGROUND, theme.colors.PRIMARY.FOREGROUND, theme.colors.PRIMARY.BACKGROUND));
});
var Row = styled.pre(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: left;\n  margin: 0;\n  font-size: 13px;\n  line-height: 20px;\n  color: currentcolor;\n\n  ", "\n"], ["\n  text-align: left;\n  margin: 0;\n  font-size: 13px;\n  line-height: 20px;\n  color: currentcolor;\n\n  ", "\n"])), function (_a) {
    var prompt = _a.prompt;
    return prompt && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      &:before {\n        content: '$ ';\n        user-select: none;\n      }\n    "], ["\n      &:before {\n        content: '$ ';\n        user-select: none;\n      }\n    "])));
});
var CopyButton = styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: currentcolor;\n  outline: none;\n  cursor: pointer;\n  position: absolute;\n  top: 3px;\n  right: 0;\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n  outline: none;\n  padding: 4px 12px;\n  border-radius: 0 5px 5px 0;\n  transition: opacity 0.15s ease;\n\n  &:hover {\n    opacity: 0.5;\n  }\n"], ["\n  color: currentcolor;\n  outline: none;\n  cursor: pointer;\n  position: absolute;\n  top: 3px;\n  right: 0;\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n  outline: none;\n  padding: 4px 12px;\n  border-radius: 0 5px 5px 0;\n  transition: opacity 0.15s ease;\n\n  &:hover {\n    opacity: 0.5;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.jsx.map